import axios from '../service/axios/axios'

export default {
  // 推送处方到药监局
  uploadPrescription(data) {
    return axios({
      method: 'post',
      url: 'platform/prescription/uploadPrescription',
      data,
    })
  },
  // 推送问诊记录到药监局
  uploadConsul(data) {
    return axios({
      method: 'post',
      url: 'platform/prescription/uploadConsul',
      data: data,
    })
  },
}
